/**
 * Tabs navigator mixin
 * @description Will be used to persist the user current tab in the UI
 * @author {Jatin Kamboj}
 */
export default {
  name: "TabsNavigatorMixin",

  /**
   * -------------- Data Properties -------------
   */
  data() {
    return {
      activeTab: 0,
      tabsName: [],
    };
  },
  /**
   * -------------- Methods -------------
   */
  methods: {
    /**
     * Computes the current active tab selected by the user on the basis of the route
     * active_tab query param
     */
    computeSelectedTab() {
      const selectedTab = this.$route.query?.active_tab || 0;
      const currentTab = selectedTab
        ? this.tabsName.findIndex(
            ({ query }) => query.toLowerCase() === selectedTab
          )
        : 0;

      // Sets activeTab (v-model property assigned to the v-tabs component) with computed tab value
      this.activeTab = currentTab;
    },
    /**
     * Changes the route with current selected tab name in the route query
     * @param active_tab String Selected tab by the user
     */
    onTabChange(active_tab) {
      const isCurrentTabActive = this.$route.query?.active_tab === active_tab;

      if (!isCurrentTabActive) {
        this.$router.push({ path: this.$route.path, query: { active_tab } });
      }
    },
  },
  /**
   * -------------- Watching properties -------------
   */
  watch: {
    /**
     * Watches $route query property and computes the active tab
     */
    "$route.query"(val, oldVal) {
      const areDiff = val?.active_tab !== oldVal?.active_tab;
      areDiff && this.computeSelectedTab();
    },
  },
  /**
   * -------------- Created lifecycle hook -------------
   */
  created() {
    this.computeSelectedTab();
  },
};
